import { Artwork_Bool_Exp } from '../../../schema/commonSchemaRemoteTypes';
import {
  AppliedListingModifier,
  ARTWORK_QUERY_CONDITION_IN,
  FILTERS_DEFAULT_VALUE,
  isOptionType,
  ListingModifier,
  ListingModifierOption,
} from './types';

export type ArtistOptionType = {
  id: number;
  name: string;
};

export const generatArtistFilterOption = ({ id, name }: ArtistOptionType): ListingModifierOption => ({
  name,
  value: id,
  key: 'ARTWORK_QUERY_CONDITION_IN',
  payload: { artist_context_id: { _in: [id] } },
});

export const getArtistFilter = (): ListingModifier => ({
  type: 'ARTIST',
  allOptions: [
    {
      value: FILTERS_DEFAULT_VALUE,
      name: 'filterStrings.artist.all',
      key: 'ARTWORK_QUERY_CONDITION_IN',
      payload: {},
    },
  ],
});

export const getAppliedArtistFilter = (
  seriesOptions: ArtistOptionType[]
): AppliedListingModifier<ARTWORK_QUERY_CONDITION_IN> => {
  const artistFilter = getArtistFilter();
  const newSeriesFilterOptions = seriesOptions.map(generatArtistFilterOption);
  artistFilter.allOptions.push(...newSeriesFilterOptions);
  return {
    ...artistFilter,
    selectionType: 'MULTIPLE',
    selectedOptions: [FILTERS_DEFAULT_VALUE],
    flattenSelectedOptions: (options, selectedOptions) => {
      const selectedModifiers = options.filter((option) => selectedOptions.includes(option.value));
      const flattenedModifiers = selectedModifiers.reduce<Artwork_Bool_Exp>((flattenedOptions, currentOption) => {
        if (
          isOptionType<ARTWORK_QUERY_CONDITION_IN>(currentOption, 'ARTWORK_QUERY_CONDITION_IN') &&
          currentOption.payload.artist_context_id?._in
        ) {
          return {
            artist_context_id: {
              _in: [...(flattenedOptions.artist_context_id?._in ?? []), ...currentOption.payload.artist_context_id._in],
            },
          };
        }
        return flattenedOptions;
      }, {});

      return {
        key: 'ARTWORK_QUERY_CONDITION_IN',
        name: 'APPLIED_SERIES_FILTER',
        value: -1,
        payload: flattenedModifiers,
      };
    },
  };
};
